import React, { FC } from 'react';

import { Checkbox } from '~/eds/src/components/Checkbox/Checkbox';
import { Label } from '~/eds/src/components/Label/Label';
import { Text } from '~/eds/src/components/Text/Text';

import { ESignatureIntegrationUser } from '../../types';

type UserRowProps = {
  item: ESignatureIntegrationUser;
  userName: string;
  searchKeyword?: string;
  isSelected: boolean;
  onToggleUser: () => void;
};

export const UserRow: FC<UserRowProps> = React.memo(
  ({ item, userName, searchKeyword = '', isSelected, onToggleUser }) => {
    return (
      <Label>
        <Checkbox
          id={item.id}
          labelVariant="body-medium"
          option={{ label: userName, value: item.id }}
          value={isSelected}
          onChange={onToggleUser}
          name={item.type}
          search={searchKeyword}
        />
        <Text variant="tiny" color="text.secondary" pl={6}>
          {item.attributes.external_user_email}
        </Text>
      </Label>
    );
  },
);
